<template>
  <div class="m-item text-xs-center subheading">
    <div style="min-height: 160px">
        <div class="icon_img">
          <img class="icon" :src="icon" width="92" height="92">
        </div>
      <p class="font-weight-medium">{{name}}</p>
    </div>
  </div>
  
</template>

<script>
import {find} from 'lodash'
import manips from '@/data/manips.js'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      icon: '',
      name: ''
    }
  },
  mounted: function () {
    this.config = find(manips, {'id': this.id});

    this.icon = this.config.iconFileName;
    this.name = this.config.displayName;
  }
}
</script>

<style scoped>
.icon {
  cursor: pointer;
  border-radius: 18px;
  border: #DAEDFF solid 2px;
  background: white;
}
.icon_img :hover {
  border: #3296F3 solid 2px;
}

p {
  font-size: 18px;
  padding: 0 24px;
}
a {
  color: #56544d;
}
</style>
